var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4013 6.07825C16.0706 6.07825 15.8027 6.34629 15.8027 6.67691V14.9242H1.19733V6.67691C1.19733 6.34629 0.929371 6.07825 0.598667 6.07825C0.267964 6.07825 0 6.34621 0 6.67691V15.5228C0 15.8534 0.267964 16.1215 0.598667 16.1215H16.4013C16.732 16.1215 17 15.8534 17 15.5228V6.67691C17 6.34621 16.732 6.07825 16.4013 6.07825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0758 12.3522C8.18811 12.4646 8.34033 12.5276 8.49918 12.5276C8.65795 12.5276 8.81017 12.4646 8.92256 12.3522L11.5066 9.76808C11.7404 9.53428 11.7404 9.1552 11.5066 8.92148C11.2728 8.6876 10.8938 8.68768 10.66 8.92148L9.09793 10.4835L9.09825 1.47733C9.09825 1.14671 8.83028 0.878662 8.49958 0.878662C8.16895 0.878662 7.90091 1.14671 7.90091 1.47733L7.90059 10.4836L6.34038 8.92332C6.10659 8.68952 5.72759 8.68944 5.49371 8.92332C5.25991 9.15711 5.25991 9.53611 5.49371 9.76991L8.0758 12.3522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.ea5d10de6fce49f72cfe535595d1eedc.svg";
export { ForwardRef as ReactComponent };